import { createBrowserRouter } from 'react-router-dom';

import { Role } from '@app/domain-interfaces';
import { Auth } from '@app/web-components';
import { Common } from '@app/web-pages';
import { Snapshot } from '@app/web-t3-pages';

import App from './app';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: ':snapshotId',
        element: (
          <Auth.ProtectedRoute allowedRoles={[Role.NODE_ACCESS_EXTERNAL_TSMC]}>
            <Snapshot.LandingPage />
          </Auth.ProtectedRoute>
        ),
      },
      // {
      //   path: 'approvals',
      //   element: (
      //     <Auth.ProtectedRoute allowedRoles={[Role.NODE_ACCESS_EXTERNAL_TSMC]}>
      //       <Layout style={{ padding: '0 24px' }}>
      //         <Approvals.ExternalLandingPage />
      //       </Layout>
      //     </Auth.ProtectedRoute>
      //   ),
      // },
    ],
  },
  {
    path: 'access-forbidden',
    element: <Common.AccessForbiddenPage />,
  },
]);
